import React from "react";
import { Box } from "@mui/material";
import { ROW_HEIGHT } from "./MABranchConstants";

/**
 * Renders the L-shaped branch visualization lines for MA Inventory subtable.
 * Follows the same visual pattern as RfqBranchVisualization.
 *
 * @param {Object} props
 * @param {Array}  props.rows           - subtable dealer rows
 * @param {string} props.animationState - "entering" | "entered"
 * @param {Object} props.linePosition   - { left, connector } pixel strings
 * @param {string} props.connectorWidth - pixel string for horizontal line
 * @param {number} props.branchWidth    - numeric width (px) of the visualization column
 */
const MABranchVisualization = ({
  rows,
  animationState,
  linePosition,
  connectorWidth,
  branchWidth,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: `${branchWidth}px`,
        backgroundColor: "transparent",
        flexShrink: 0,
        // Connector lines intentionally removed.
        // "&::before": {
        //   ...vertical line + bottom-left L-shape styles
        // },
      }}
    >
      {/* Connector ticks intentionally removed. */}
      {rows.map((_, index) => {
        return (
          <Box
            key={index}
            sx={{
              height: ROW_HEIGHT,
              position: "relative",
              // "&::before": {
              //   ...horizontal connector tick styles
              // },
            }}
          />
        );
      })}
    </Box>
  );
};

export default MABranchVisualization;
